import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FollowUpService } from 'src/app/services/follow-up.service';
import { ErrorComponent } from '../error/error.component';
import { SuccessFollowUpComponent } from '../success-follow-up/success-follow-up.component';

@Component({
  selector: 'app-follow-up-modal',
  templateUrl: './follow-up-modal.component.html',
  styleUrls: ['./follow-up-modal.component.scss']
})
export class FollowUpModalComponent implements OnInit {
  personalInfoForm: FormGroup;

  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
    private followUpService: FollowUpService
  ) { }

  ngOnInit(): void {
    const request = this.getRequestData();
    this.personalInfoForm = this.formBuilder.group({
      cqNumber: [{ value: request.cqReferenceNo, disabled: true }, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNumber: ['', [Validators.required, Validators.pattern(/^05\d{8}$/)]],
      reason: ['', [Validators.required, Validators.maxLength(200)]],
    });
  }

  private getRequestData() {
    const request = JSON.parse(localStorage.getItem('TR'));
    return request || { cqReferenceNo: "14294837" };
  }

  dismiss() {
    this.modalController.dismiss({ dismissed: true });
  }

  async openBottomSheet(component: any, data?: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data},
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  async onSubmit() {
    if (this.personalInfoForm.valid) {
      const request = this.getRequestData();
      const cqNumber = request.cqReferenceNo;
      const token = sessionStorage.getItem('token');
      const payload = {
        email: this.personalInfoForm.value.email,
        contactNumber: this.personalInfoForm.value.contactNumber,
        message: this.personalInfoForm.value.reason,
        token,
        cqNumber
      };
  
      try{
        await this.dismiss();
        this.followUpService.createFollowUp(cqNumber, payload).subscribe(
          async (res: any) => {
            if (res?.succss) {
              await this.openBottomSheet(SuccessFollowUpComponent);
            } else {
              await this.openBottomSheet(ErrorComponent, {
                errorCode: "FOLLOWUP",
                error: "Network error occurred. Please check your connection."
              });
            }
          },
          async (error) => {
            if (error?.error?.errorDescription === 'FOLLOWUP_EXCEEDED') {
              await this.openBottomSheet(ErrorComponent, {
                errorCode: "FOLLOWUP",
                error: "Follow-up limit exceeded. Please try again later."
              });
            } else if (error?.error?.errorDescription === 'GEN_ERR_FOLLOWUP') {
              await this.openBottomSheet(ErrorComponent, {
                errorCode: "FOLLOWUP",
                error: "System error occurred. Please try again later."
              });
            } else {
              await this.openBottomSheet(ErrorComponent, {
                errorCode: "FOLLOWUP",
                error: "Network error occurred. Please check your connection."
              });
            }
          }
        );
          
      }catch(error){
        console.log(error)
      }
    }
  }
  
}
